/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavMissionOtg
 */
export interface OutputUavMissionOtg {
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionOtg
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionOtg
     */
    name?: string;
}

/**
 * Check if a given object implements the OutputUavMissionOtg interface.
 */
export function instanceOfOutputUavMissionOtg(value: object): boolean {
    return true;
}

export function OutputUavMissionOtgFromJSON(json: any): OutputUavMissionOtg {
    return OutputUavMissionOtgFromJSONTyped(json, false);
}

export function OutputUavMissionOtgFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMissionOtg {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function OutputUavMissionOtgToJSON(value?: OutputUavMissionOtg | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

